import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Loaders from '../../../components/loaders/Loaders';
import {
  syncBatchCourseAccess,
  getCourseModuleAccess,
  getCourseSubModuleAccess,
  getCourseSubModuleNAccess,
  getCourseModuleTestSeriesAccess,
  getCourseSubModuleNAccessTestSeries,
  syncBatchCourseAccessTestSeries,
} from '../../../service/admin/adminCourses.service';
import { FaFolder } from 'react-icons/fa';
import { truncateString } from '../../../helpers/helpers';
import { FaFile } from 'react-icons/fa6';
import { getAllVideoFromModules } from '../../../service/admin/adminVideoes.service';
import Swal from 'sweetalert2';
import { getAllBatchStudentCourseAccess } from '../../../service/admin/adminBatch.service';
import MUITableGrid from '../../../components/tables/MUITableGrid';
import { getCourseSubModuleAccessTestSeries } from '../../../service/admin/adminStudent.service';

export default function AdminCourseAccess() {
  const location = useLocation();
  const courseId: string =
    location.pathname.split('/')[location.pathname.split('/').length - 2];
  const batchId: string =
    location.pathname.split('/')[location.pathname.split('/').length - 1];
  const URLQuery: any = new URLSearchParams(location.search);
  const [activeTab, setActiveTab] = React.useState<number>(0);
  const [activeCategory, setActiveCategory] = React.useState<string>('mod');
  const [loading, setLoading] = React.useState<boolean>(false);
  const [modulesList, setModulesList] = React.useState<any>([]);
  const [testModulesList, setTestModulesList] = React.useState<any>([]);
  const [editData, setEditData] = React.useState<any>([]);
  const [breadcrumb, setBreadcrumb] = React.useState<any>([
    {
      name: 'Home',
      mod: '',
      sub: '',
    },
  ]);

  const [submitData, setSubmitData] = React.useState<any>([]);
  const [studentList, setStudentList] = React.useState<any>([]);
  const [selectedStudent, setSelectedStudent] = React.useState<any>([]);
  const fetchModules = async (type: string) => {
    setLoading(true);
    setActiveCategory('mod');
    let get: any;
    if (type === 'videos') {
      get = await getCourseModuleAccess(courseId);
      if (get?.status === 'success') {
        setModulesList(get?.message);
      }
    } else if (type === 'test') {
      get = await getCourseModuleTestSeriesAccess(courseId);
      if (get?.status === 'success') {
        setTestModulesList(get?.message);
      }
    }

    setLoading(false);
  };
  const fetchSubModules = async (type: string, moduleId: string) => {
    setLoading(true);
    setActiveCategory('subMod');
    if (editData.length > 0) {
      return Swal.fire({
        html: '<h5>Save or Reset changes to continue...</h5>',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'Save',
        denyButtonText: `Reset`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          Swal.fire('Saved!', '', 'success');
        } else if (result.isDenied) {
          setEditData([]);
          setLoading(false);
          handleRoot('videos');
        }
      });
    }
    let get: any;
    if (type === 'videos') {
      get = await getCourseSubModuleAccess(courseId, moduleId);
      if (get?.status === 'success') {
        setModulesList(get?.message);
      }
    } else if (type === 'test') {
      get = await getCourseSubModuleAccessTestSeries(courseId, moduleId);
      if (get?.status === 'success') {
        setTestModulesList(get?.message);
      }
    }

    setLoading(false);
  };
  const fetchAllStudent = async () => {
    let get: any = await getAllBatchStudentCourseAccess(batchId);
    if (get?.status === 'success') {
      let dt: any = [];
      if (get?.status == 'success') {
        if (get?.message) {
          get.message?.map((item: any, index: number) => {
            dt.push({
              id: index + 1,
              uuid: item.student.id,
              name: item.student.name,
              email: item.student.email,
              phone: item.student.phone,
            });
          });
          setStudentList(dt);
        }
      }
    }
  };
  const fetchSubNModuleAccess = async (
    type: string,
    moduleId: string,
    subModuleId: string
  ) => {
    setLoading(true);
    setActiveCategory('subNMod');
    let get: any;
    if (type === 'videos') {
      get = await getCourseSubModuleNAccess(courseId, moduleId, subModuleId);
      if (get?.status === 'success') {
        setModulesList(get?.message);
      }
    }else if (type === 'test') {
      get = await getCourseSubModuleNAccessTestSeries(courseId, moduleId, subModuleId);
      if (get?.status === 'success') {
        setTestModulesList(get?.message);
      }
    }
   
    setLoading(false);
  };
  const fetchAllVideos = async (moduleId: string, subModuleId: string) => {
    setLoading(true);
    console.log(moduleId,subModuleId)
    setActiveCategory('videos');
    let get: any = await getAllVideoFromModules(moduleId, subModuleId);
    if (get?.status === 'success') {
      setModulesList(get?.message);
    }
    setLoading(false);
  };
  useEffect(() => {
    setModulesList([]);
    setTestModulesList([]);
    if (activeTab === 0) {
      fetchModules('videos');
    } else if (activeTab === 1) {
      fetchModules('test');
    }
  }, [setActiveTab, activeTab]);
  console.log(modulesList);
  const handleSubModulesAccess = async (
    types: string,
    moduleId: string,
    name?: string
  ) => {
    setBreadcrumb([
      {
        name: name,
        mod: moduleId,
        sub: '',
      },
    ]);
    fetchSubModules(types, moduleId);
  };
  const handleSubNModulesAccess = async (
    types: string,
    moduleId: string,
    subModuleId: string,
    dir: string,
    name?: string
  ) => {
    console.log(types, moduleId, subModuleId, dir, name);
    setBreadcrumb((prev: any) => {
      const newItem = { name, mod: moduleId, sub: subModuleId, types: dir };
      const keyToCheck = `${newItem.mod}-${newItem.sub}`;
      // Find index of existing dir with same mod-sub
      const existingIndex = prev.findIndex(
        (item: any) =>
          item.types === 'dir' && `${item.mod}-${item.sub}` === keyToCheck
      );

      if (existingIndex !== -1) {
        // If found, remove that and all after it
        return [
          ...prev.slice(0, existingIndex),
          newItem, // Add fresh version
        ];
      }

      // Else, add normally
      return [...prev, newItem];
    });
    fetchSubNModuleAccess(types, moduleId, subModuleId);
  };
  const handleRoot = (types: string) => {
    setBreadcrumb([
      {
        name: 'Home',
        mod: '',
        sub: '',
      },
    ]);
    fetchModules(activeTab === 0? 'videos' : 'test');
  };
  const handleEditData = (
    types: string,
    moduleId: string,
    subModuleId: string | null = null
  ) => {
    const newItem = {
      course: courseId,
      mod: moduleId,
      sub: subModuleId,
      types,
    };

    let updatedEditData: any[];

    if (editData.length === 0) {
      updatedEditData = [newItem];
    } else {
      const keyToCheck = `${newItem.mod}-${newItem.sub}`;
      const filteredPrev = editData.filter(
        (item: any) => !(`${item.mod}-${item.sub}` === keyToCheck)
      );
      updatedEditData = [...filteredPrev, newItem];
    }

    // Set the state
    setEditData(updatedEditData);
    // Now you can use the updated value right after
    console.log('Updated editData in real-time:', updatedEditData);

    // 👇 Do something immediately using the updated data
    // doSomethingWith(updatedEditData);
  };
  const handleSaveChanges = async () => {
    console.log(breadcrumb);
    console.log(editData);
    if (editData.length > 0) {
      let newData: any = [];
      let course: any = null;
      if (breadcrumb.length === 1) {
        if (editData.length > 0) {
          course = editData[0].course;
          editData.map((e: any) => {
            newData.push({
              module: e.mod,
              subMod: e.sub,
              types: e.types,
            });
          });
        }
      } else {
        course = editData[0].course;
        breadcrumb.map((e: any) => {
          newData.push({
            module: e.mod,
            subMod: e.sub,
            types: null,
          });
        });
        editData.map((e: any) => {
          newData.push({
            module: e.mod,
            subMod: e.sub,
            types: e.types,
          });
        });
      }
      setSubmitData({
        course: course,
        data: newData,
      });
      fetchAllStudent();
      setActiveCategory('students');
    } else {
      return Swal.fire({
        html: '<h5>select at least one module</h5>',
        confirmButtonText: 'ok',
      });
    }
    // await getAllModuleSubmodules(editData)
  };
  const handleSyncAccess = async () => {
    const students = studentList.filter((e: any) =>
      selectedStudent.includes(e.id)
    );
    const uuidArray = students.map((item: any) => item.uuid);
    if(activeTab === 0){
      let submit: any = await syncBatchCourseAccess(uuidArray, submitData);
      if (submit?.status === 'success') {
        Swal.fire('Synced!', '', 'success');
      }
    }else if(activeTab === 1){
      let submit: any = await syncBatchCourseAccessTestSeries(uuidArray, submitData);
      if (submit?.status ==='success') {
        Swal.fire('Synced!', '','success');
      }
    }
  };

  return (
    <>
      <div className="bg-gray-300 px-2 py-3 rounded-lg">
        <p className="text-xl font-bold">{URLQuery.get('name')}</p>
      </div>
      <div className="my-2 justify-between items-center flex gap-4">
        <div className="flex gap-3">
          <button
            disabled={activeTab === 0 ? true : false}
            onClick={() => setActiveTab(0)}
            className={`${activeTab === 0 ? 'bg-purple-700 text-white' : 'bg-gray-400'} px-4 py-2 font-semibold rounded-lg  `}
          >
            Videos
          </button>
          <button
            disabled={activeTab === 1 ? true : false}
            onClick={() => setActiveTab(1)}
            className={`${activeTab === 1 ? 'bg-purple-700 text-white' : 'bg-gray-400'} px-4 py-2 font-semibold rounded-lg  `}
          >
            Test Series
          </button>
        </div>
        <div>
          {editData.length > 0 && (
            <div className="flex gap-2">
              {selectedStudent.length > 0 ? (
                <button
                  onClick={handleSyncAccess}
                  className="bg-purple-900 text-white px-4 py-2 font-semibold rounded-lg"
                >
                  Sync Access
                </button>
              ) : (
                <button
                  onClick={handleSaveChanges}
                  className="bg-purple-700 text-white px-4 py-2 font-semibold rounded-lg"
                >
                  Save Changes
                </button>
              )}
              <button
                onClick={() => setEditData([])}
                className="bg-red-700 text-white px-4 py-2 font-semibold rounded-lg"
              >
                Reset Changes
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="my-2 bg-gray-300 p-2 rounded-lg flex flex-row gap-1">
        {breadcrumb.map((e: any, index: number) => (
          <div key={index} className="flex gap-2 items-center">
            {index === 0 ? (
              <>
                <button
                  onClick={() => handleRoot('videos')}
                  className={`text-md  ${index + 1 === breadcrumb.length ? 'text-gray-900' : 'text-gray-500'}`}
                >
                  {e?.name}
                </button>
              </>
            ) : breadcrumb.length === index + 1 ? (
              <>
                /{' '}
                <button
                  className={`text-md  ${index + 1 === breadcrumb.length ? 'text-gray-900' : 'text-gray-500'}`}
                >
                  {e?.name}
                </button>
              </>
            ) : (
              <>
                /
                <button
                  onClick={() =>
                    e.types === 'dir'
                      ? handleSubNModulesAccess('videos', e.mod, e.sub, e.name)
                      : handleSubNModulesAccess('videos', e.mod, e.sub, e.name)
                  }
                  className={`text-md  ${index + 1 === breadcrumb.length ? 'text-gray-900' : 'text-gray-500'}`}
                >
                  {e?.name}
                </button>
              </>
            )}
          </div>
        ))}
      </div>
      <div className="my-2 min-h-[30vh] w-full">
        {loading ? (
          <Loaders type="spinner" />
        ) : (
          <div className="w-full">
            {activeCategory === 'mod' ? (
              activeTab === 0 ? (
                <div>
                  {modulesList.length > 0 ? (
                    <div className="flex gap-2 flex-wrap flex-row my-3">
                      {modulesList?.map((item: any, index: number) => (
                        <div
                          key={index}
                          className="flex flex-col  bg-white p-3 rounded-lg"
                        >
                          <div className="flex gap-2 items-center ">
                            <FaFolder className="text-[2rem] text-yellow-500 " />
                            <p
                              onClick={() =>
                                handleSubModulesAccess(
                                  'videos',
                                  item?.videoModule.id,
                                  item?.videoModule.name
                                )
                              }
                              className="font-semibold hover:cursor-pointer"
                              data-tooltip={item?.videoModule.name}
                            >
                              {truncateString(item?.videoModule.name, 20)}
                            </p>
                          </div>
                          {editData.filter(
                            (e: any) =>
                              e.mod === item?.videoModule.id &&
                              e.types === 'add'
                          ).length === 0 ? (
                            <button
                              onClick={() =>
                                handleEditData('add', item?.videoModule.id)
                              }
                              className="bg-blue-700 mt-4 text-white px-4 py-1 font-semibold rounded-lg"
                            >
                              Add Access
                            </button>
                          ) : null}
                          {editData.filter(
                            (e: any) =>
                              e.mod === item?.videoModule.id &&
                              e.types === 'subtract'
                          ).length === 0 ? (
                            <button
                              onClick={() =>
                                handleEditData('subtract', item?.videoModule.id)
                              }
                              className="bg-red-700 mt-1 text-white px-4 py-1 font-semibold rounded-lg"
                            >
                              Remove Access
                            </button>
                          ) : null}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="w-full flex justify-center items-center">
                      <p>No Modules Found</p>
                    </div>
                  )}
                </div>
              ) : activeTab === 1 ? (
                <div>
                  {testModulesList.length > 0 ? (
                    <div className="flex gap-2 flex-wrap flex-row my-3">
                      {testModulesList?.map((item: any, index: number) => (
                        <div
                          key={index}
                          className="flex flex-col  bg-white p-3 rounded-lg"
                        >
                          <div className="flex gap-2 items-center ">
                            <FaFolder className="text-[2rem] text-yellow-500 " />
                            <p
                              onClick={() =>
                                handleSubModulesAccess(
                                  'test',
                                  item?.testModules?.id,
                                  item?.testModules?.name
                                )
                              }
                              className="font-semibold hover:cursor-pointer"
                              data-tooltip={item?.testModules?.name}
                            >
                              {truncateString(item?.testModules?.name, 20)}
                            </p>
                          </div>
                          {editData.filter(
                            (e: any) =>
                              e.mod === item?.testModules?.id &&
                              e.types === 'add'
                          ).length === 0 ? (
                            <button
                              onClick={() =>
                                handleEditData('add', item?.testModules?.id)
                              }
                              className="bg-blue-700 mt-4 text-white px-4 py-1 font-semibold rounded-lg"
                            >
                              Add Access
                            </button>
                          ) : null}
                          {editData.filter(
                            (e: any) =>
                              e.mod === item?.testModules?.id &&
                              e.types === 'subtract'
                          ).length === 0 ? (
                            <button
                              onClick={() =>
                                handleEditData(
                                  'subtract',
                                  item?.testModules?.id
                                )
                              }
                              className="bg-red-700 mt-1 text-white px-4 py-1 font-semibold rounded-lg"
                            >
                              Remove Access
                            </button>
                          ) : null}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="w-full flex justify-center items-center">
                      <p>No Modules Found</p>
                    </div>
                  )}
                </div>
              ) : null
            ) : null}
            {activeCategory === 'subMod' ? (
              activeTab === 0 ? (
                <div>
                  {modulesList.length > 0 ? (
                    <div className="flex gap-2 flex-wrap flex-row my-3">
                      {modulesList?.map((item: any, index: number) => (
                        <div
                          key={index}
                          className="flex flex-col  bg-white p-3 rounded-lg"
                        >
                          <div className="flex gap-2 items-center ">
                            {item?.videoSubModule.types === 'dir' ? (
                              <FaFolder className="text-[2rem] text-yellow-500 " />
                            ) : (
                              <FaFile className="text-[2rem] text-blue-500 " />
                            )}
                            <p
                              onClick={() =>
                                item?.videoSubModule.types === 'dir'
                                  ? handleSubNModulesAccess(
                                      'videos',
                                      item?.videoSubModule.videoModule.id,
                                      item?.videoSubModule.id,
                                      item?.videoSubModule.types,
                                      item?.videoSubModule.name
                                    )
                                  : fetchAllVideos(
                                      item?.videoSubModule.videoModule.id,
                                      item?.videoSubModule.id
                                    )
                              }
                              className="font-semibold hover:cursor-pointer"
                              data-tooltip={item?.videoSubModule}
                            >
                              {truncateString(item?.videoSubModule.name, 20)}
                            </p>
                          </div>
                          {editData.filter(
                            (e: any) =>
                              e.mod === item?.videoSubModule.videoModule.id &&
                              e.types === 'add' &&
                              e.sub === item?.videoSubModule.id
                          ).length === 0 ? (
                            <button
                              onClick={() =>
                                handleEditData(
                                  'add',
                                  item?.videoSubModule.videoModule.id,
                                  item?.videoSubModule.id
                                )
                              }
                              className="bg-blue-700 mt-4 text-white px-4 py-1 font-semibold rounded-lg"
                            >
                              Add Access
                            </button>
                          ) : null}
                          {editData.filter(
                            (e: any) =>
                              e.mod === item?.videoSubModule.videoModule.id &&
                              e.types === 'subtract' &&
                              e.sub === item?.videoSubModule.id
                          ).length === 0 ? (
                            <button
                              onClick={() =>
                                handleEditData(
                                  'subtract',
                                  item?.videoSubModule.videoModule.id,
                                  item?.videoSubModule.id
                                )
                              }
                              className="bg-red-700 mt-1 text-white px-4 py-1 font-semibold rounded-lg"
                            >
                              Remove Access
                            </button>
                          ) : null}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="w-full flex justify-center items-center">
                      <p>No Modules Found</p>
                    </div>
                  )}
                </div>
              ) : activeTab === 1 ? (
                <div>
                  {testModulesList.length > 0 ? (
                    <div className="flex gap-2 flex-wrap flex-row my-3">
                      {testModulesList?.map((item: any, index: number) => (
                        <div
                          key={index}
                          className="flex flex-col  bg-white p-3 rounded-lg"
                        >
                          <div className="flex gap-2 items-center ">
                            {item?.testSubModules.test_type === 1 ? (
                              <FaFolder className="text-[2rem] text-yellow-500 " />
                            ) : (
                              <FaFile className="text-[2rem] text-blue-500 " />
                            )}
                            <p
                              onClick={() =>
                                item?.testSubModules.test_type === 1
                                  && handleSubNModulesAccess(
                                      'test',
                                      item?.testSubModules.testModules.id,
                                      item?.testSubModules.id,
                                      item?.testSubModules.fk_dir_id,
                                      item?.testSubModules.name
                                    )
                                  
                              }
                              className="font-semibold hover:cursor-pointer"
                              data-tooltip={item?.testSubModules}
                            >
                              {truncateString(item?.testSubModules.name, 20)}
                            </p>
                          </div>
                          {editData.filter(
                            (e: any) =>
                              e.mod === item?.testSubModules.testModules.id &&
                              e.types === 'add' &&
                              e.sub === item?.testSubModules.id
                          ).length === 0 ? (
                            <button
                              onClick={() =>
                                handleEditData(
                                  'add',
                                  item?.testSubModules.testModules.id,
                                  item?.testSubModules.id
                                )
                              }
                              className="bg-blue-700 mt-4 text-white px-4 py-1 font-semibold rounded-lg"
                            >
                              Add Access
                            </button>
                          ) : null}
                          {editData.filter(
                            (e: any) =>
                              e.mod === item?.testSubModules.testModules.id &&
                              e.types === 'subtract' &&
                              e.sub === item?.testSubModules.id
                          ).length === 0 ? (
                            <button
                              onClick={() =>
                                handleEditData(
                                  'subtract',
                                  item?.testSubModules.testModules.id,
                                  item?.testSubModules.id
                                )
                              }
                              className="bg-red-700 mt-1 text-white px-4 py-1 font-semibold rounded-lg"
                            >
                              Remove Access
                            </button>
                          ) : null}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="w-full flex justify-center items-center">
                      <p>No subModule Found</p>
                    </div>
                  )}
                </div>
              ) : null
            ) : null}
            {activeCategory === 'subNMod' ? (
             activeTab === 0 ?
             <div>
             {modulesList.length > 0 ? (
               <div className="flex gap-2 flex-wrap flex-row my-3">
                 {modulesList?.map((item: any, index: number) => (
                   <div
                     key={index}
                     className="flex flex-col  bg-white p-3 rounded-lg"
                   >
                     <div className="flex gap-2 items-center ">
                       {item?.videoSubModule.types === 'dir' ? (
                         <FaFolder className="text-[2rem] text-yellow-500 " />
                       ) : (
                         <FaFile className="text-[2rem] text-blue-500 " />
                       )}
                       <p
                         onClick={() =>
                           item?.videoSubModule.types === 'dir'
                             ? handleSubNModulesAccess(
                                 'videos',
                                 item?.videoSubModule.videoModule.id,
                                 item?.videoSubModule.id,
                                 item?.videoSubModule.types,
                                 item?.videoSubModule.name
                               )
                             : fetchAllVideos(
                                 item?.videoSubModule.videoModule.id,
                                 item?.videoSubModule.id
                               )
                         }
                         className="font-semibold hover:cursor-pointer"
                         data-tooltip={item?.videoSubModule.name}
                       >
                         {truncateString(item?.videoSubModule.name, 20)}
                       </p>
                     </div>
                     {editData.filter(
                       (e: any) =>
                         e.mod === item?.videoSubModule.videoModule.id &&
                         e.types === 'add' &&
                         e.sub === item?.videoSubModule.id
                     ).length === 0 ? (
                       <button
                         onClick={() =>
                           handleEditData(
                             'add',
                             item?.videoSubModule.videoModule.id,
                             item?.videoSubModule.id
                           )
                         }
                         className="bg-blue-700 mt-4 text-white px-4 py-1 font-semibold rounded-lg"
                       >
                         Add Access
                       </button>
                     ) : null}
                     {editData.filter(
                       (e: any) =>
                         e.mod === item?.videoSubModule.videoModule.id &&
                         e.types === 'subtract' &&
                         e.sub === item?.videoSubModule.id
                     ).length === 0 ? (
                       <button
                         onClick={() =>
                           handleEditData(
                             'subtract',
                             item?.videoSubModule.videoModule.id,
                             item?.videoSubModule.id
                           )
                         }
                         className="bg-red-700 mt-1 text-white px-4 py-1 font-semibold rounded-lg"
                       >
                         Remove Access
                       </button>
                     ) : null}
                   </div>
                 ))}
               </div>
             ) : (
               <div className="w-full flex justify-center items-center">
                 <p>No Modules Found</p>
               </div>
             )}
           </div>
           : 
           activeTab === 1? 
           <div>
           {testModulesList.length > 0 ? (
             <div className="flex gap-2 flex-wrap flex-row my-3">
               {testModulesList?.map((item: any, index: number) => (
                 <div
                   key={index}
                   className="flex flex-col  bg-white p-3 rounded-lg"
                 >
                   <div className="flex gap-2 items-center ">
                     {item?.testSubModules.fk_dir_id === null ? (
                       <FaFolder className="text-[2rem] text-yellow-500 " />
                     ) : (
                       <FaFile className="text-[2rem] text-blue-500 " />
                     )}
                     <p
                       onClick={() =>
                         item?.testSubModules.fk_dir_id === null
                           && handleSubNModulesAccess(
                               'test',
                               item?.testSubModules.testModules.id,
                               item?.testSubModules.id,
                               item?.testSubModules.fk_dir_id,
                               item?.testSubModules.name
                             )
                       }
                       className="font-semibold hover:cursor-pointer"
                       data-tooltip={item?.testSubModules.name}
                     >
                       {truncateString(item?.testSubModules.name, 20)}
                     </p>
                   </div>
                   {editData.filter(
                     (e: any) =>
                       e.mod === item?.testSubModules.testModules.id &&
                       e.types === 'add' &&
                       e.sub === item?.testSubModules.id
                   ).length === 0 ? (
                     <button
                       onClick={() =>
                         handleEditData(
                           'add',
                           item?.testSubModules.testModules.id,
                           item?.testSubModules.id
                         )
                       }
                       className="bg-blue-700 mt-4 text-white px-4 py-1 font-semibold rounded-lg"
                     >
                       Add Access
                     </button>
                   ) : null}
                   {editData.filter(
                     (e: any) =>
                       e.mod === item?.testSubModules.testModules.id &&
                       e.types === 'subtract' &&
                       e.sub === item?.testSubModules.id
                   ).length === 0 ? (
                     <button
                       onClick={() =>
                         handleEditData(
                           'subtract',
                           item?.testSubModules.testModules.id,
                           item?.testSubModules.id
                         )
                       }
                       className="bg-red-700 mt-1 text-white px-4 py-1 font-semibold rounded-lg"
                     >
                       Remove Access
                     </button>
                   ) : null}
                 </div>
               ))}
             </div>
           ) : (
             <div className="w-full flex justify-center items-center">
               <p>No submodule Found</p>
             </div>
           )}
         </div>
         :null
            ) : null}
            {activeCategory === 'videos' ? (
              <div>
                {modulesList.length > 0 ? (
                  <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 my-3">
                    {modulesList?.map((item: any, index: number) => (
                      <div
                        key={index}
                        className="flex flex-col gap-2 m-1   rounded-lg "
                      >
                        <div className="flex flex-col w-full gap-6 border hover:cursor-pointer  bg-white p-3 rounded-lg ">
                          <img
                            className="h-[200px] w-full"
                            src={`${item?.thumbnail}`}
                            alt=""
                          />
                          <p data-tooltip={item?.name}>
                            {truncateString(item?.name, 20)}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="w-full flex justify-center items-center">
                    <p>No Modules Found</p>
                  </div>
                )}
              </div>
            ) : null}
            {activeCategory === 'students' ? (
              <div>
                {studentList.length > 0 ? (
                  <MUITableGrid
                    onSubmit={setSelectedStudent}
                    name="allBatchStudentsList"
                    checkbox={true}
                    dataObject={studentList}
                  />
                ) : (
                  <div className="w-full flex justify-center items-center">
                    <p>No Students Found</p>
                  </div>
                )}
              </div>
            ) : null}
          </div>
        )}
      </div>
    </>
  );
}
